import { Box, Button, Card, CardContent, FormLabel, Grid, makeStyles, Paper, Tab, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import Footer from "pages/LandingPages/Author/sections/Footer";
import MKBox from "components/MKBox";
import bgImage from "../../assets/images/city-profile.jpg"
import { useState } from "react";
import { post } from "../../utility/fetchTwo";
import { ClipLoader } from "react-spinners";
import { Table } from 'antd';
import { numberWithCommas } from "utility/general";
import notification from "utility/notification";


const columns = [
    {
        title: 'Year',
        dataIndex: 'year',
        key: 'year',
        width: "80px",
        render: (text) => <p>{text}</p>,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (text) => <p>N{numberWithCommas(text)}</p>,
    },

]

const futureColumns = [
    {
        title: 'Year',
        dataIndex: 'year',
        key: 'year',
        width: "80px",
        render: (text) => <p>{text}</p>,
    },
    {
        title: 'Principal',
        dataIndex: 'principal',
        key: 'principal',
        render: (text) => <p>N{numberWithCommas(parseFloat(text).toFixed(2))}</p>,
    },
    {
        title: 'Contribution',
        dataIndex: 'contribution',
        key: 'contribution',
        render: (text) => <p>N{numberWithCommas(parseFloat(text).toFixed(2))}</p>,
    },
    {
        title: 'Interest',
        dataIndex: 'interest',
        key: 'interest',
        render: (text) => <p>N{numberWithCommas(parseFloat(text).toFixed(2))}</p>,
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
        key: 'balance',
        render: (text) => <p>N{numberWithCommas(parseFloat(text).toFixed(2))}</p>,
    },

]



export default function PensionCalculator() {

    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [avc, setAVC] = useState({});
    const [future, setFuture] = useState({});
    const [monthly, setMonthly] = useState({});
    const [avcDataArray, setAvcDataArray] = useState([]);
    const [avcTable, setAvcTable] = useState([]);
    const [avcMessage, setAvcMessage] = useState([]);
    const [monthlyMessage, setMonthlyMessage] = useState([]);
    const [viewAvcTable, setViewAvcTable] = useState(false);
    const [monthlyDataArray, setMonthlyDataArray] = useState([]);
    const [futureDataArray, setFutureDataArray] = useState([]);
    const [futureMessage, setFutureMessage] = useState([]);
    const [html, setHTML] = useState({ __html: "" });

    const [avcPayload, setAvcPayload] = useState({
        grossSalary: 0,
        avcMonthlyContribution: 0,
        contributionYears: 0,
        MonthlyTaxation: 18,
        avcReturn: 12
    })

    const [futurePayload, setFuturePayload] = useState({
        returnRate: 8,
        yearsLeft: 0,
        monthlyContribution: 0,
        currentBalance: 0
    })

    const [monthlyPayload, setMonthlyPayload] = useState({
        currentBalance: 0,
        desiredRSA: 0,
        yearsLeft: 0,
        returnrate: 8
    })


    const handleChangeAVC = (e) => {
        setAvcPayload({
            ...avcPayload,
            [e.target.name]: Number(e.target.value)
        })
    }

    const handleChangeFuture = (e) => {

        setFuturePayload({
            ...futurePayload,
            [e.target.name]: Number(e.target.value)
        })
    }

    const handleChangeMonthly = (e) => {
        setMonthlyPayload({
            ...monthlyPayload,
            [e.target.name]: Number(e.target.value)
        })
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        console.log(newValue);
    };

    function createData(label, value) {
        return { label, value };
    }




    const calculateAVC = async () => {
        if (!validateAvc()) {
            return;
        }
        setLoading(true)
        let res = await post("/Calculator/calculateAVC", avcPayload)
        console.log(res);
        setAVC(res.data);
        setAvcDataArray(
            res.data.dataArray.map((item, index) => (
                {
                    key: index,
                    year: item?.label,
                    amount: item?.value
                }
            ))
        )

        setAvcMessage(res?.message)

        setAvcTable(
            res?.data?.tableData?.map((item, index) => (
                {
                    key: index,
                    year: item?.year,
                    principal: item?.principal,
                    contribution: item?.contribution,
                    interest: item?.interest,
                    balance: item?.balance
                }
            ))
        )

        console.log(
            res.data.dataArray.map((item, index) => (
                createData(item?.label, item?.value)
            ))
        )
        setLoading(false)
    }

    const validateFuture = () => {
        if (futurePayload.yearsLeft < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid number of years",
                    type: "danger"
                }
            )
            return false
        }
        if (futurePayload.monthlyContribution < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid monthly contribution",
                    type: "danger"
                }
            )
            return false
        }
        if (futurePayload.currentBalance < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid current balance",
                    type: "danger"
                }
            )
            return false
        }

        return true;

    }

    const validateAvc = () => {
        if (avcPayload.grossSalary < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid gross salary",
                    type: "danger"
                }
            )
            return false
        }
        if (avcPayload.avcMonthlyContribution < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid monthly contribution",
                    type: "danger"
                }
            )
            return false
        }
        if (avcPayload.contributionYears < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid number of years",
                    type: "danger"
                }
            )
            return false
        }

        return true;

    }

    const validateMonthlyContribution = () => {
        if (monthlyPayload.currentBalance < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid current balance",
                    type: "danger"
                }
            )
            return false
        }
        if (monthlyPayload.desiredRSA < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid desired RSA",
                    type: "danger"
                }
            )
            return false
        }
        if (monthlyPayload.yearsLeft < 1) {
            notification(
                {
                    title: "Error",
                    message: "Please enter a valid number of years",
                    type: "danger"
                }
            )
            return false
        }

        return true;

    }

    const calculateFuture = async () => {
        if (!validateFuture()) {
            return;
        }
        setLoading(true)
        let res = await post("/Calculator/CalculateFutureValuePension", futurePayload)
        console.log(res);
        setFuture(res?.data);
        setFutureMessage(res?.data?.message);
        setFutureDataArray(
            res?.data?.projection?.map((item, index) => (
                {
                    key: index,
                    year: item?.year,
                    principal: item?.principal,
                    contribution: item?.contribution,
                    interest: item?.interest,
                    balance: item?.balance
                }
            ))
        )
        setLoading(false)
    }

    const calculateMonthly = async () => {
        if (!validateMonthlyContribution()) {
            return;
        }
        setLoading(true)
        let res = await post("/Calculator/calculatemonthlypayment", monthlyPayload)
        console.log(res);
        setMonthly(res.data);
        setMonthlyDataArray(
            res?.data?.tableData
        )
        setMonthlyMessage(res?.data?.message);
        setLoading(false)
    }


    return (
        <div style={{
        }} className="flex w-100 ">
            <div style={{ width: "100%" }}>

                <Box gap={2} sx={{ width: '100%', mt: "40px", display: "flex", justifyContent: "center" }}>
                    <Tabs sx={{ width: "60%" }} value={value} onChange={handleChange} centered>
                        <Tab label="AVC Returns" />
                        <Tab label="Future Value" />
                        <Tab label="Monthly Payment" />
                    </Tabs>
                </Box>


                {
                    value === 0 && <Grid container sx={{ mb: 5, mt: 1 }} justifyContent={"center"} spacing={3}>
                        <Grid item md={8} xs={10}>
                            <Card>
                                <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h4" >
                                    AVC Returns
                                </Typography>
                                <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }} spacing={2}>
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeAVC} name="grossSalary" variant="outlined" label="Gross Salary" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeAVC} name="avcMonthlyContribution" variant="outlined" label="AVC  Monthly Contribution" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeAVC} name="contributionYears" variant="outlined" label="Contribution Years" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} disabled value={avcPayload?.MonthlyTaxation} type="number" onChange={handleChangeAVC} name="MonthlyTaxation" variant="outlined" label="Monthly Taxation (%)" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} disabled value={avcPayload?.avcReturn} type="number" onChange={handleChangeAVC} name="avcReturn" variant="outlined" label="AVC Return (%)" />
                                    <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
                                        <Button disabled={loading} sx={{ mt: 2, width: "30%", mr: "10px", color: "black", backgroundColor: "#A6CE39", border: "1px solid #A6CE39", px: 2, py: 2, border: "1px solid green" }} onClick={calculateAVC} variant="contained"> Calculate {loading && <ClipLoader />}</Button>
                                        <Button onClick={() => setViewAvcTable(!viewAvcTable)} sx={{ mt: 2, width: "30%", mr: "10px", color: "black", backgroundColor: "#A6CE39", border: "1px solid #A6CE39", px: 2, py: 2, border: "1px solid green" }} variant="contained">Toggle View Table</Button>
                                    </Box>

                                    {(avcDataArray.length > 0 || avcTable?.length > 0) && (!viewAvcTable ? <div style={{ marginTop: "40px", width: "80%" }} className="m-t-40">
                                        <Table className="w-100" columns={columns} dataSource={avcDataArray} />
                                    </div>
                                        :
                                        <div style={{ marginTop: "40px", width: "80%" }} className="m-t-40">
                                            <Table className="w-100" columns={futureColumns} dataSource={avcTable} />
                                        </div>)}

                                </CardContent>

                            </Card>

                        </Grid>

                    </Grid>

                }

                {
                    value === 1 && <Grid container sx={{ mb: 5, mt: 1 }} justifyContent={"center"} spacing={3}>
                        <Grid item md={8} xs={10}>

                            <Card>
                                <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h4" >
                                    Future Value
                                </Typography>
                                <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }} spacing={2}>
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeFuture} name="currentBalance" variant="outlined" label="Current RSA Balance" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeFuture} name="monthlyContribution" variant="outlined" label="Monthly Contribution" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeFuture} name="yearsLeft" variant="outlined" label="Years left" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} disabled value={futurePayload?.returnRate} type="number" onChange={handleChangeFuture} name="returnRate" variant="outlined" label="Return Rate (%)" />
                                    <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
                                        <Button sx={{ mt: 2, width: "60%", mr: "10px", color: "black", backgroundColor: "#A6CE39", border: "1px solid #A6CE39", px: 2, py: 2, border: "1px solid green" }} onClick={calculateFuture} variant="contained">Calculate</Button>
                                        {/* <Button sx={{ mt: 2, width: "30%", mr: "10px", color: "black", backgroundColor: "#A6CE39", border: "1px solid #A6CE39", px: 2, py: 2, border: "1px solid green" }} variant="outlined">View Table</Button> */}
                                    </Box>

                                    <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h5" >
                                        {futureMessage}
                                    </Typography>
                                    {futureDataArray.length > 0 && <div style={{ marginTop: "40px", width: "80%" }} className="m-t-40">
                                        <Table className="w-100" columns={futureColumns} dataSource={futureDataArray} />
                                    </div>}

                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                }

                {
                    value === 2 && <Grid container sx={{ mb: 5, mt: 1 }} justifyContent={"center"} spacing={3}>
                        <Grid item md={8} xs={10}>

                            <Card>
                                <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h4" >
                                    Monthly Payment
                                </Typography>
                                <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }} spacing={2}>
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeMonthly} name="currentBalance" variant="outlined" label="Current RSA Balance" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeMonthly} name="desiredRSA" variant="outlined" label="Desired RSA Balance" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} type="number" onChange={handleChangeMonthly} name="yearsLeft" variant="outlined" label="How Many Years Do You Want To Work?" />
                                    <TextField sx={{ mb: "10px", width: "60%" }} disabled value={monthlyPayload?.returnrate} type="number" onChange={handleChangeMonthly} name="returnRate" variant="outlined" label="Return Rate (%)" />
                                    <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
                                        <Button sx={{ mt: 2, width: "60%", mr: "10px", color: "black", backgroundColor: "#A6CE39", border: "1px solid #A6CE39", px: 2, py: 2, border: "1px solid green" }} onClick={calculateMonthly} variant="contained">Calculate</Button>
                                        {/* <Button sx={{ mt: 2, width: "30%", mr: "10px", color: "black", backgroundColor: "#A6CE39", border: "1px solid #A6CE39", px: 2, py: 2, border: "1px solid green" }} variant="outlined">View Table</Button> */}
                                    </Box>

                                    <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h5" >
                                        {monthlyMessage}
                                    </Typography>
                                    <div dangerouslySetInnerHTML={{ __html: monthlyDataArray }} style={{ marginTop: "40px", width: "80%" }} className="m-t-40" />

                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                }



                {
                }

                <Footer />
            </div>
        </div>

    );
}